module.exports = __webpack_public_path__ + "static/media/YM50_0.cf73a6f7.jpg";